import React, { useEffect } from 'react';
import { optimizePageImages, preloadImages } from '../utils/imageOptimization';

const PerformanceOptimizer = () => {
  useEffect(() => {
    // Preload critical resources
    const preloadCriticalResources = () => {
      const criticalResources = [
        '/static/css/main.css',
        '/static/js/main.js',
        'https://fonts.googleapis.com/css2?family=Inter:wght@300;400;500;600;700&display=swap'
      ];

      criticalResources.forEach(resource => {
        const link = document.createElement('link');
        link.rel = 'preload';
        link.href = resource;
        link.as = resource.includes('.css') ? 'style' : 'script';
        if (resource.includes('fonts')) {
          link.as = 'style';
          link.crossOrigin = 'anonymous';
        }
        document.head.appendChild(link);
      });
    };

    // Optimize images with advanced techniques
    const optimizeImages = () => {
      // Use our custom image optimization
      optimizePageImages();
      
      // Add loading and decoding attributes
      const images = document.querySelectorAll('img');
      images.forEach(img => {
        if (!img.loading) {
          img.loading = 'lazy';
        }
        if (!img.decoding) {
          img.decoding = 'async';
        }
        // Add fetchpriority for above-the-fold images
        if (img.getBoundingClientRect().top < window.innerHeight) {
          img.setAttribute('fetchpriority', 'high');
        }
      });
    };

    // Add performance monitoring
    const addPerformanceMonitoring = () => {
      if ('performance' in window) {
        window.addEventListener('load', () => {
          setTimeout(() => {
            const perfData = performance.getEntriesByType('navigation')[0];
            if (perfData) {
              // Page Load Performance data available
              // Performance metrics: domContentLoaded, loadComplete, totalLoadTime
            }
          }, 0);
        });
      }
    };

    // Initialize optimizations
    preloadCriticalResources();
    optimizeImages();
    addPerformanceMonitoring();

    // Cleanup
    return () => {
      // Cleanup if needed
    };
  }, []);

  return null; // This component doesn't render anything
};

export default PerformanceOptimizer;
